import React from 'react';

const DisplayError = () => {
    return (
        <div>
            <h2 className="text-bold">404 Error</h2>
        </div>
    );
};

export default DisplayError;